import { Typography } from 'modules/v2/foundation/Typography';
import { ListItemTextContainer } from './styled';
export function ListItemText(props) {
    const { primary, secondary, truncate = true } = props;
    return (<ListItemTextContainer>
      {primary && (<Typography $truncate={truncate} $appearance="300" $fontSize="medium" $lineHeight="neutralized">
          {primary}
        </Typography>)}
      {secondary && (<Typography $truncate={truncate} $appearance="100" $fontSize="small" $lineHeight="neutralized">
          {secondary}
        </Typography>)}
    </ListItemTextContainer>);
}
